import wrapper from './api';
import { trace } from '../utils/notifyParent';
import { ApiError, InitializationError, SumUpError } from '../utils/errors';
import { TRACING_EVENTS } from '../../shared/constants';
import { PAYMENT_METHODS } from '../constants';

function sumupService({ sumupBaseUrl }) {
	if (!sumupBaseUrl) {
		throw new InitializationError('SumUpBaseUrl should be provided');
	}
	const onError = (error => {
		const serviceIsUnavailable = error instanceof SumUpError
			&& (error.isNetworkError() || error.isHTTPBadGateway() || error.isHTTPServiceUnavailable());
		const details = error instanceof ApiError && error.details;
		if (serviceIsUnavailable) {
			trace(TRACING_EVENTS.SUMUP_REQUEST_BLOCKED, {
				details,
			});
		}  else {
			trace(TRACING_EVENTS.SERVER_ERROR, {
				type: 'SumUp service',
				reason: error.message,
				details
			});
		}
	});

	const api = wrapper({
		request: {
			baseURL: sumupBaseUrl,
			withCredentials: false,
			headers: {
				'Content-type': 'application/json',
			},
			errorHandled: true,
		},
		error: SumUpError,
		onError,
	});

	async function processCheckout({ checkoutId, mandate, type, ...paymentMethodData }) {
		const url = `/checkouts/${checkoutId}`;

		const { cardholderName, cardnumber, expiryYear, expiryMonth, cvv, zipCode, iban, companyName, firstName, lastName } = paymentMethodData;

		let data;
		if (type === PAYMENT_METHODS.creditCard) {
			data = {
				payment_type: 'card',
				mandate,
				card: {
					name: cardholderName,
					number: cardnumber,
					expiry_year: expiryYear,
					expiry_month: expiryMonth,
					cvv,
				}
			};
			if (zipCode) {
				data.card.zip_code = zipCode;
			}
		} else if (type === PAYMENT_METHODS.directDebit) {
			data = {
				payment_type: 'direct_debit',
				mandate,
				direct_debit: {
					iban,
					company_name: companyName || (firstName + ' ' + lastName),
				},
			};
		}

		return api.put(url, data).catch((err) => {
			trace(TRACING_EVENTS.SCA_VERIFICATION_FAILED, { reason: err.message });

			throw err;
		});
	}

	return {
		processCheckout,
	};
}

export default sumupService;
